import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";

export default function AgentStripeReauthHandler({ baseUrl }) {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const stripe_id = searchParams.get("stripe_id");

    if (stripe_id) {
      var formData = new FormData();
      formData.append("stripe_id", stripe_id);
      axios.post(
        `${baseUrl}/reauthAgentStripe`,
        formData
      )
      .then((res) => {
        if(res.data.status === "OK") {
          window.location.href = res.data.data;
        } else {
          console.error("Reauth failed:", res.data);
        }
      })
      .catch((err) => {
        console.error(err);
      });
    }
  }, []);

  return null; // or loading spinner
}